<template>
  <div id="header" class="header" :style="height">
    <div id="overlay-1">
      <div class="header-top">
        <div>
          河南省计划生育扶助保障信息系统
        </div>
      </div>
      <div class="loginColumns animated fadeInDown">
        <div class="row">
          <div class="row-left">
            <img src="../../src/assets/images/loginbg3.png" alt="">
          </div>
          <div class="row-right">
            <div class="ibox-content">
              <el-form ref="loginForm" :rules="rules" :model="loginForm">
                <div class="ibox-content-heder">
                  用户登录
                </div>
                <el-form-item prop="name" class="inputitem">
                  <div class="input-img input-img1">
                    <img src="../../src/assets/images/login1.png" alt="">
                  </div>
                  <div class="input-item">
                    <el-input size="medium" v-model.trim="loginForm.name" clearable placeholder="登录名" v-focus tabindex=1 @keyup.enter.native="onSubmit"></el-input>
                  </div>

                </el-form-item>
                <el-form-item prop="password" class="inputitem captchacode">
                  <div class="input-img input-img2">
                    <img src="../../src/assets/images/login2.png" alt="">
                  </div>
                  <div class="input-item">
                    <el-input size="medium" v-model.trim="loginForm.password" clearable show-password placeholder="登录密码" tabindex=2 @keyup.enter.native="onSubmit"></el-input>
                  </div>
                </el-form-item>
                <el-form-item prop="captchacode" class="captchacode">
                  <el-col :span="15" class="inputitems">
                    <div class="input-img input-img2">
                      <img src="../../src/assets/images/login3.png" alt="">
                    </div>
                    <div class="input-item inputitemmedium">
                      <el-input size="medium" v-model.trim="loginForm.captchacode" clearable placeholder="验证码" tabindex=3 class="clearradius" @keyup.enter.native="onSubmit"></el-input>
                    </div>
                  </el-col>
                  <el-col :span="9" style="font-size: 0;">
                    <el-image :src="captchadata" class="imageslot" style="width:100%;height:48px;vertical-align:middle;object-fill:fill;cursor:pointer" @click="reFreshCaptchaCode">
                      <div slot="error" class="image-slot">
                        加载中<span class="dot">...</span>
                      </div>
                    </el-image>
                    <!-- <img style="width:100%;height:48px;vertical-align:middle;object-fill:fill;cursor:pointer" class="imageslot" src="../../src/assets/images/cc_code.png" alt=""> -->
                  </el-col>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" size="medium" class="full-width" :loading="loading" :disabled="disabled" @click="onSubmit" tabindex=4>登录</el-button>
                </el-form-item>
                <!-- <el-form-item>
                                        <el-button type="warning" size="medium" class="full-width"  @click="dialogpwdVisible = true">修改密码</el-button>
                                    </el-form-item> -->
              </el-form>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import { capthcaCodeModule, loginModule } from '@/request/login.js'
import { baseconfig, } from '@/config.js'
import router from '../router.js'
import $ from 'jquery'
export default {
  data() {
    //   var validatePass = (rule, value, callback) => {
    //     if (value === '') {
    //       callback(new Error('请输入密码'))
    //     } else {
    //        var regex = /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[~!@#$%^&*-]).{8,16}$/
    //       if(regex.test(value)){
    //           callback()
    //       }else{
    //            callback(new Error('请输入8~16位包含字母、数字、特殊符号（~!@#$%^&*-）的密码'))
    //       }
    //     }
    //   };
    var validateCallLoginName = (rule, value, callback) => {
      if (this.errors.name) {
        callback(new Error(this.errors.name));
      } else {
        callback()
      }
    };
    var validateCallLoginPassword = (rule, value, callback) => {
      if (this.errors.password) {
        callback(new Error(this.errors.password));
      } else {
        callback()
      }
    };
    var validateCallCaptchaCode = (rule, value, callback) => {
      if (this.errors.captchacode) {
        callback(new Error(this.errors.captchacode));
      } else {
        callback()
      }
    };
    return {
      loading: false,
      disabled: false,
      loginForm: {
        name: '',
        password: '',
        captchacode: ''
      },
      height: '',
      captchadata: '',
      captchakey: '1',
      errors: {
        name: '',
        password: '',
        captchacode: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入登录名', trigger: 'blur' },
          { validator: validateCallLoginName }
        ],
        password: [
          //  { validator:  validatePass, trigger: 'blur' },
          { validator: validateCallLoginPassword }
        ],
        captchacode: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { validator: validateCallCaptchaCode }
        ]

      }
    }
  },
  created() {
    this.height = 'height:' + $(window).height() + 'px'
    this.getCaptchaCode()
  },
  directives: {
    focus: {
      inserted: function (el) {
        el.querySelector('input').focus()
      }
    }
  },
  methods: {
    onSubmit() {
      //     router.push('main')
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loading = true
          this.disabled = true
          var params = new URLSearchParams()
          params.append('login_name', this.loginForm.name)
          params.append('login_pwd', this.loginForm.password)
          params.append('captcha_code', this.loginForm.captchacode)

          var header = { 'CaptchaKey': this.captchakey }
          // console.log(header)
          // var header = {'CaptchaKey':'1221'}
          loginModule.adminLogin(params, header).then((response) => {
            this.loading = false
            this.disabled = false
            switch (response.data.code) {
              case 100:
                if (response.data.result.tokenCode == 1) {
                  this.$store.dispatch('admin/setAdminID', response.data.result.adminToken)
                  this.$store.dispatch('admin/setToken', response.data.result.token)
                  this.$store.dispatch('admin/setIsNeedComplate', response.data.result.isNeedComplate)
                  this.$store.dispatch('admin/setisNeedEditPwd', response.data.result.isNeedEditPwd)
                  this.$store.dispatch('admin/setISSYS', response.data.result.isSys)
                  this.$store.dispatch('tab/clearTab')
                  if (this.$route.query.backurl) {
                    //router.push(this.$route.query.backurl)
                    this.$router.push({//你需要接受路由的参数再跳转
                      path: this.$route.query.backurl
                    });
                  } else {

                    router.push('main')
                  }

                } else {
                  //获取token失败
                  this.$message.error('登录失败,请重新登录');
                }
                break;
              case 100002:
                this.$message.error(baseconfig.no_permission_message);
                break;
              default:
                this.$message.error(response.data.message);
                break;
            }

          })
        } else {
          return false;
        }
      })
    },
    reFreshCaptchaCode() {
      if (this.captchakey.length > 0) {
        capthcaCodeModule.refreshCaptchaCode({ 'CaptchaKey': this.captchakey }).then((response) => {
          var code = response.data.code
          if (code == 100) {
            this.captchakey = response.data.result.captchaKey
            this.captchadata = response.data.result.captchaCode
          }
        })
      }
    },
    getCaptchaCode() {
      capthcaCodeModule.getCaptchaCode().then((response) => {
        var code = response.data.code
        if (code == 100) {
          console.log(response.data.result.captchaCode)
          this.captchakey = response.data.result.captchaKey
          this.captchadata = response.data.result.captchaCode
        }
      })

    }
  }
}
</script>
<style scoped>
@import '../common/font.css';
#header {
  background: url('../assets/images/loginbg2.png') no-repeat center top fixed;
  background-size: cover;
  /* height: 100%; */
  min-height: 650px !important;
}
#overlay-1 {
  position: relative;
  height: 100%;
}
.header-top {
  min-width: 900px;
  text-align: center;
  color: #fff;
  padding: 30px 0;
  box-sizing: border-box;
}
.header-top > div {
  font-size: 70px;
  font-family: PingFang;
}
.animated {
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  z-index: 100;
}
.fadeInDown {
  -webkit-animation-name: fadeInDown;
  animation-name: fadeInDown;
}
.loginColumns {
  width: 80%;
  min-width: 900px;
  margin: 0 auto;
  padding: 0px 20px 20px 20px;
  box-sizing: border-box;
}
.row {
  margin-right: -15px;
  margin-left: -15px;
  display: flex;
  /* align-items: center; */
  justify-content: space-between;
}
.row-left {
  width: 58%;
}
.row-left img {
  width: 100%;
  object-fit: cover;
  /* margin-top:-20%; */
}
.row-right {
  width: 48%;
  display: flex;
  justify-content: flex-end;
  padding: 0px 60px;
  box-sizing: border-box;
}
.row-right >>> .el-input__inner {
  height: 43px;
  line-height: 43px;
}
*:before,
*:after {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
.clearfix:before,
.clearfix:after,
.dl-horizontal dd:before,
.dl-horizontal dd:after,
.container:before,
.container:after,
.container-fluid:before,
.container-fluid:after,
.row:before,
.row:after,
.form-horizontal .form-group:before,
.form-horizontal .form-group:after,
.btn-toolbar:before,
.btn-toolbar:after,
.btn-group-vertical > .btn-group:before,
.btn-group-vertical > .btn-group:after,
.nav:before,
.nav:after,
.navbar:before,
.navbar:after,
.navbar-header:before,
.navbar-header:after,
.navbar-collapse:before,
.navbar-collapse:after,
.pager:before,
.pager:after,
.panel-body:before,
.panel-body:after,
.modal-header:before,
.modal-header:after,
.modal-footer:before,
.modal-footer:after {
  display: table;
  content: ' ';
}
@media (min-width: 992px) {
  .col-md-6 {
    float: left;
    width: 50%;
  }
}
.ibox-content {
  width: 70%;
  background-color: #fff;
  color: inherit;
  padding: 0px 50px 7% 50px;
  border-color: #e7eaec;
  border-image: none;
  border-style: solid solid none;
  border-width: 1px 0;
  clear: both;
  border-radius: 8px;
  box-sizing: border-box;
  box-shadow: 0px 0px 16px 0px rgb(211 210 210 / 40%);
  /* max-height:500px; */
  margin-top: 12%;
  min-width: 350px;
  max-height: 500px;
  max-width: 460px;
}
.m-t {
  margin-top: 15px;
}
.full-width {
  width: 100% !important;
}
.logindialog {
  top: 0px;
  background-color: rgba(10, 4, 4, 0.4);
  padding-top: 15vh;
}
.logindialog >>> .el-dialog {
  border-radius: 8px;
}
.logindialog >>> .el-dialog__close {
  position: absolute;
  top: -20px;
  right: 0px;
  padding: 0;
  background: transparent;
  border: none;
  outline: none;
  cursor: pointer;
  font-size: 16px;
  font-size: 23px !important;
}
.logindialog >>> .el-dialog__header {
  position: inherit;
  width: inherit;
  box-sizing: border-box;
  border-top-right-radius: 20px;
  border-top-left-radius: 20px;
}
.logindialog >>> .el-dialog__footer {
  padding: 20px;
  padding-bottom: 10px;
  padding-top: 10px;
  text-align: right;
  box-sizing: border-box;
  border-top: 1px solid #f0f0f0;
}
.logindialog >>> .el-dialog__body {
  padding-top: 30px;
}
.logindialog >>> .el-dialog__close {
  top: -15px;
}
.ibox-content-heder {
  text-align: left;
  color: #007fe1;
  font-size: 26px;
  font-family: PingFang;
  font-weight: bold;
  margin: 12% 0px 12% 0px;
  font-family: sans-serif;
}
.row >>> .el-button--medium {
  padding: 16px 20px;
  background: #007fe1;
  margin-top: 6%;
}
.row >>> .el-button--medium span {
  font-size: 17px;
}
.row >>> .el-input__prefix {
  font-size: 16px;
  margin-right: 10px;
  display: flex;
  align-items: center;
}
.row-right {
  height: 100%;
}
/*  */
/* .inputitem{
        width: 100%;
    } */
.inputitem >>> .el-form-item__content {
  width: 100%;
  display: flex;
  align-items: center;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  line-height: 45px;
}
.input-item {
  width: 100%;
}
.input-item >>> .el-input__inner {
  border-radius: 0px;
  border: none !important;
  font-size: 18px;
}
.input-item >>> .el-input__inner {
  background: #fff !important;
  padding-left: 5px !important;
  font-size: 18px;
}
.input-img {
  padding: 0px 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.input-img img {
  width: 23px;
  object-fit: cover;
}
.inputitems {
  display: flex;
  align-items: center;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  border: 1px solid #dcdfe6;
  line-height: 45px;
}
.captchacode {
  margin-top: 28px !important;
}

/* 适配 */
@media only screen and (max-width: 1700px) and (min-width: 1600px) {
  .header-top > div {
    font-size: 68px;
  }
}
@media only screen and (max-width: 1599px) and (min-width: 1500px) {
  .header-top > div {
    font-size: 65px;
  }
  /* .ibox-content-heder{
            margin:35px 0px 35px 0px;
        } */
}
@media only screen and (max-width: 1499px) and (min-width: 1400px) {
  .header-top > div {
    font-size: 62px;
  }
}
@media only screen and (max-width: 1399px) and (min-width: 1300px) {
  .header-top > div {
    font-size: 60px;
  }
  .ibox-content {
    max-height: 430px;
  }
}
@media only screen and (max-width: 1299px) and (min-width: 1200px) {
  .header-top > div {
    font-size: 56px;
  }
  .ibox-content {
    max-height: 400px;
  }
}
@media only screen and (max-width: 1199px) and (min-width: 1100px) {
  .header-top > div {
    font-size: 53px;
  }
  .ibox-content {
    max-height: 400px;
  }
}
@media only screen and (max-width: 1099px) and (min-width: 900px) {
  .header-top > div {
    font-size: 51px;
  }
  .ibox-content {
    max-height: 400px;
  }
}
@media only screen and (max-width: 899px) and (min-width: 300px) {
  .header-top > div {
    font-size: 50px;
  }
  .ibox-content {
    max-height: 420px;
  }
}
@media only screen and (min-height: 300px) and (max-height: 800px) {
  .ibox-content {
    height: 420px !important;
  }
  .ibox-content-heder {
    margin: 8% 0px 8% 0px !important;
  }
  .inputitem >>> .el-form-item__content {
    line-height: 35px;
    height: 35px;
  }
  .row-right >>> .el-input__inner {
    line-height: 33px !important;
    height: 33px !important;
  }
  .inputitemmedium >>> .el-input__inner {
    height: 33px !important;
  }
  .input-img img {
    width: 18px !important;
  }
  .inputitems {
    line-height: 37px !important;
    height: 38px !important;
  }
  .imageslot {
    height: 38px !important;
    line-height: 37px;
    margin-top: -2px;
  }
  .row >>> .el-button--medium {
    padding: 13px 20px;
  }
}
</style>
